import React from 'react';
import UploadForm from './components/UploadForm';
import './styles.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Simplified Lab Report Interpreter</h1>
      </header>
      <main>
        <UploadForm />
      </main>
    </div>
  );
}

export default App;
